<template>
  <validation-observer ref="simpleRules">
    <departments-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="submitStatus"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import DepartmentsItemForm from '@/views/Defines/Departments/ItemForm.vue'

export default {
  name: 'Edit',
  components: {
    DepartmentsItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['departments/dataItem']
    },
    saveData() {
      return this.$store.getters['departments/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: this.$t('common.toast.success'), icon: 'CheckIcon', text: val.message,
        })
        this.$router.push('/app/defines/departments')
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: this.$t('common.toast.error'), icon: 'XIcon', text: val.message,
        })
        this.submitStatus = false
      }
      this.getDataItem()
    },
  },
  created() {
    this.getDataItem()
  },
  methods: {
    getDataItem() {
      this.$store.dispatch('departments/getDataItem', this.$route.params.id)
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('departments/saveData', this.itemData)
        } else {
          this.showToast({
            title: this.$t('common.toast.warning'),
            icon: 'XIcon',
            text: this.$t('common.requiredFields'),
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
